/**
 * 表示する値: パチンコ
 */
export const RADIO_CONTENTS_PACHI = [
  { koumokumei: 'アウト', key: 'out', checked: true, isShow: true },
  { koumokumei: 'アウト維持率', key: 'iji_ritsu_out', checked: false, isShow: true },
  { koumokumei: '期間アウト', key: 'kikan_out', checked: false, isShow: true },
  { koumokumei: '台粗利', key: 'arari', checked: false, isShow: true },
  { koumokumei: '玉粗利', key: 'tama_arari', checked: false, isShow: true },
  { koumokumei: '累計台粗利', key: 'ruikei_arari', checked: false, isShow: true },
  { koumokumei: '台売上', key: 'uriage', checked: false, isShow: true },
  { koumokumei: '中古価格', key: 'used_machine_price', checked: false, isShow: true },
  { koumokumei: '設置台数', key: 'display_daisu', checked: false, isShow: true  }
];

/**
 * 表示する値: スロット
 */
export const RADIO_CONTENTS_SLOT = [
  { koumokumei: 'アウト', key: 'out', checked: true, isShow: true },
  { koumokumei: 'アウト維持率', key: 'iji_ritsu_out', checked: false, isShow: true },
  { koumokumei: '期間アウト', key: 'kikan_out', checked: false, isShow: true },
  { koumokumei: '台粗利', key: 'arari', checked: false, isShow: true },
  { koumokumei: 'メダル粗利', key: 'tama_arari', checked: false, isShow: true },
  { koumokumei: '累計台粗利', key: 'ruikei_arari', checked: false, isShow: true },
  { koumokumei: '台売上', key: 'uriage', checked: false, isShow: true },
  { koumokumei: '中古価格', key: 'used_machine_price', checked: false, isShow: true },
  { koumokumei: '設置台数', key: 'display_daisu', checked: false, isShow: true  }
];

/**
 * 表示するデータ
 */
export const CHECKBOX_CONTENTS_SETTEI = [
  { koumokumei: 'すべて', key: 'all', checked: true },
  { koumokumei: '1', key: 'settei_1', checked: true },
  { koumokumei: '2', key: 'settei_2', checked: true },
  { koumokumei: '3', key: 'settei_3', checked: true },
  { koumokumei: '4', key: 'settei_4', checked: true },
  { koumokumei: '5', key: 'settei_5', checked: true },
  { koumokumei: '6', key: 'settei_6', checked: true },
];

